import { Theme } from '@mui/material/styles';

function reactDatepickerGlobalStyles(theme: Theme) {
  return {
    '.custom-datepicker': {
      backgroundColor: '#f9f9f9',
      color: '#333333',
      borderRadius: `${theme.shape.borderRadius * 3} !important`,
      padding: '10px',
      fontFamily:
        'Raleway, Inter, system-ui, Avenir, Helvetica, Arial, sans-serif !important',
      boxShadow: 'none',
      border: '1px solid #e5e5e5 !important',

      '& .react-datepicker__header': {
        backgroundColor: '#e0e0e0',
        borderBottom: '1px solid #dcdcdc',
        padding: '8px 0',
        color: '#333333',
      },
      '& .react-datepicker-popper .react-datepicker__triangle': {
        stroke: 'none',
      },
      '& .react-datepicker__navigation-icon::before': {
        borderColor: '#333333ce',
      },
      '& .react-datepicker__navigation': {
        top: 15,
      },
      '& .react-datepicker__navigation--previous': {
        left: 15,
      },
      '& .react-datepicker__navigation--next': {
        right: 15,
      },

      '& .react-datepicker__day--selected, & .react-datepicker__day--in-range':
        {
          backgroundColor: `${theme.palette.primary.dark} !important`,
          color: '#ffffed !important',
          borderRadius: '50% !important',
        },

      '& .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range), .react-datepicker__day--selecting-range-end':
        {
          backgroundColor: '#c8b4ff !important',
          color: '#333333 !important',
          borderRadius: '50% !important',
        },

      '& .react-datepicker__day:hover': {
        backgroundColor: '#c8b4ff',
        color: '#333333',
        borderRadius: '50%',
      },

      '& .react-datepicker__day--keyboard-selected': {
        backgroundColor: '#c8b4ff',
        color: '#333333',
      },

      '& .react-datepicker__current-month, & .react-datepicker__navigation-icon::before':
        {
          color: '#333333',
        },

      '& .react-datepicker__day-name': {
        color: '#333333',
        fontWeight: 'bold',
      },

      '& .react-datepicker__month-container': {
        padding: '0 10px',
      },

      '& .react-datepicker__day--outside-month': {
        color: '#bdbdbd',
      },
    },
  };
}

export default function globalStyles(theme: Theme) {
  return {
    a: {
      fontWeight: 500,
      color: theme.palette.primary.main,
      textDecoration: 'inherit',
      transition: '0.15s ease-in-out',
      width: 'fit-content',
    },
    'a:hover': {
      color: theme.palette.primary.dark,
    },
    'button:hover': {
      borderColor: theme.palette.primary.main,
    },
    ...reactDatepickerGlobalStyles(theme),
  };
}
